import tw from 'twin.macro';
import 'styled-components/macro';

export const metaHeight = { lg: 310, xl: 310 };

export const CourseMetaBlock = tw.div`grid grid-cols-2 gap-2`;
